// extracted by mini-css-extract-plugin
var _1 = "t2s-";
var _2 = "t2s_";
var _3 = "t2ta";
var _4 = "t2tc";
var _5 = "t2td";
var _6 = "t2tb";
export { _1 as "header", _2 as "invertedHeader", _3 as "pngContainer", _4 as "pngLogo", _5 as "svg", _6 as "svgContainer" }
